import React, {Component} from "react";
import PropTypes from "prop-types";
import {connect} from 'react-redux';
import _ from "lodash";
import PresentationTable from "./components/PresentationTable";
import PresentationCarousel from "./components/PresentationCarousel";

class MatrixMulti extends Component {

  constructor(props){
    super(props);

    const contentRow = {};
    const contentColumn = {};
    props.details.map(detail => {
      if (detail.contentRow) {
        contentRow[detail.row] = detail.contentRow
      }

      if (detail.contentColumn) {
        contentColumn[detail.column] = detail.contentColumn
      }
    })

    this.state = {
      contentRow: contentRow,
      contentColumn: contentColumn,
      validated: false
    };

    this.handlerDetailsUpdated = this.handlerDetailsUpdated.bind(this);
    this.isAnswerDisabled = this.isAnswerDisabled.bind(this);
    this.handlerChangeContentColumn = this.handlerChangeContentColumn.bind(this);
    this.handlerChangeContentRow = this.handlerChangeContentRow.bind(this);
    this.getValidation = this.getValidation.bind(this);
  }

  handlerChangeContentColumn(column, text){
    let {contentColumn} = this.state;

    contentColumn = {
      ...contentColumn,
      [column]: text
    };

    this.setState({
      contentColumn
    }, () => this.handlerDetailsUpdated(this.props.details));
  }

  handlerChangeContentRow(row, text){
    let {contentRow} = this.state;

    contentRow = {
      ...contentRow,
      [row]: text
    };

    this.setState({
      contentRow
    }, () => this.handlerDetailsUpdated(this.props.details));
  }

  handlerDetailsUpdated(details) {
    if(Object.values(this.state.contentRow).length > 0){
      _.each(this.state.contentRow, (text, row) => {
        details = details.map(detail => {
          if(detail.row === parseInt(row)){
            detail.contentRow = text;
          }

          return detail;
        })
      });
    }
    if(Object.values(this.state.contentColumn).length > 0){
      _.each(this.state.contentColumn, (text, column) => {
        details = details.map(detail => {
          if(detail.column === parseInt(column)){
            detail.contentColumn = text;
          }

          return detail;
        })
      });
    }

    this.props.onDetailsUpdated(details);
  }

  isAnswerDisabled(rowId, columnId) {
    let isDisabled = false;
    const {details, question} = this.props;
    const {rows, columns} = this.props.question;

    const isSelected = details.filter(detail => {
      return detail.row === rowId && detail.column === columnId;
    }).length > 0;

    if(details.filter(detail => {
      const isClickedRow = parseInt(detail.row) === parseInt(rowId);
      const isClickedColumn = parseInt(detail.column) === parseInt(columnId);

      if (isClickedRow && isClickedColumn)
        return false;

      const hasClickedBlockingRow = rows.find(row => row.id === parseInt(detail.row)).blocking && detail.column === columnId;
      const hasClickedBlockingColumn = columns.find(column => column.id === parseInt(detail.column)).blocking && detail.row === rowId;

      return hasClickedBlockingColumn || hasClickedBlockingRow;
    }).length > 0){
      isDisabled = true;
    }


    if(question.rowsMax > 0){
      const selectedInRow = details.filter(detail => {
        return detail.row === rowId;
      });

      if(!isSelected && selectedInRow.length >= question.rowsMax){
        return true;
      }
    }


    return isDisabled;
  }

  validate() {
    const {question, details, validationTexts} = this.props;
    const {requiredRows, requiredColumns, columnsMin, columnsMax, rowsMin, rowsMax, rows} = this.props.question;

    let validate =  {
      valid: true,
      errors: []
    };

    if(requiredRows){
      _.each(rows, row => {
        let detailsCount = _.filter(details, detail => detail.row === row.id).length;

        if (detailsCount === 0 && row.excludeRequired === false) {
          validate.errors.push(validationTexts.requiredRows);
          return false;
        }
      });
    }

    if(requiredColumns){
      question.columns.map(column => {
        if(details.filter(detail => detail.column === column.id).length === 0){
          if(validate.errors.indexOf(validationTexts.requiredColumns) < 0){
            validate.errors.push(validationTexts.requiredColumns);
          }
        }
      })
    }

    if(columnsMin > 0){
      question.columns.map(column => {
        if (!column.excludeRequired) {
          if (details.filter(detail => detail.column === column.id).length < columnsMin) {
            if (validate.errors.indexOf(validationTexts.columnsMin) < 0) {
              validate.errors.push(validationTexts.columnsMin);
            }
          }
        }
      });
    }

    if(columnsMax > 0){
      question.columns.map(column => {
        if(details.filter(detail => detail.column === column.id).length > columnsMax){
          if(validate.errors.indexOf(validationTexts.columnsMax) < 0){
            validate.errors.push(validationTexts.columnsMax);
          }
        }
      });
    }

    if(rowsMin > 0){
      question.rows.map(row => {
        if (!row.excludeRequired) {
          if (details.filter(detail => detail.row === row.id).length < rowsMin) {
            if (validate.errors.indexOf(validationTexts.rowsMin) < 0) {
              validate.errors.push(validationTexts.rowsMin);
            }
          }
        }
      });
    }

    if(rowsMax > 0){
      question.rows.map(row => {
        if(details.filter(detail => detail.row === row.id).length > rowsMax){
          if(validate.errors.indexOf(validationTexts.rowsMax) < 0){
            validate.errors.push(validationTexts.rowsMax);
          }
        }
      });
    }

    if (!_.isEmpty(details)) {
      _.each(details, detail => {
        const row = rows.find(ans => ans.id === parseInt(detail.row));
        const contentRow = detail.contentRow;

        if (row.isOpen && _.isEmpty(contentRow) && row.openIsRequired) {
          if (validate.errors.indexOf(validationTexts.detail.rowContentEmpty) === -1){
            validate.errors.push(validationTexts.detail.rowContentEmpty);
          }
        }
      });

      details.forEach((entry) => {
        const columnToCheck = question.columns.find((column) => {
          return column.id === entry.column && !entry.contentColumn;
        })

        if (columnToCheck && columnToCheck.isOpen && columnToCheck.openIsRequired && !validate.errors.includes(validationTexts.detail.rowColumnEmpty ? validationTexts.detail.rowColumnEmpty : "Complete the open answer in the column")) {
          validate.errors.push(validationTexts.detail.rowColumnEmpty ? validationTexts.detail.rowColumnEmpty : "Complete the open answer in the column");
        }
      })
    }

    validate.valid = _.isEmpty(validate.errors);
    this.setState({validated: true});
    return validate;
  }

  getValidation() {
    const {validated} = this.state;
    const {surveyNav} = this.props;

    if (surveyNav.hideValidation) {
      return false;
    }

    return validated
  }

  presentationType(){
    const {question, details, changePage, validate, validationTexts, questionResponse} = this.props;

    switch (question.presentationType) {
      case 'table':
        return <PresentationTable
          question={question}
          details={details}
          contentColumn={this.state.contentColumn}
          contentRow={this.state.contentRow}
          validationTexts={validationTexts}
          onDetailsUpdated={this.handlerDetailsUpdated}
          onChangeContentColumn={this.handlerChangeContentColumn}
          onChangeContentRow={this.handlerChangeContentRow}
          changePage={changePage}
          isAnswerDisabled={this.isAnswerDisabled}
          validated={this.getValidation()}
          intl={this.props.intl}
            questionResponse={questionResponse}
        />;
      case 'carousel':
        return <PresentationCarousel
          question={question}
          details={details}
          contentColumn={this.state.contentColumn}
          contentRow={this.state.contentRow}
          onDetailsUpdated={this.handlerDetailsUpdated}
          onChangeContentColumn={this.handlerChangeContentColumn}
          onChangeContentRow={this.handlerChangeContentRow}
          changePage={changePage}
            validationTexts={validationTexts}
          isAnswerDisabled={this.isAnswerDisabled}
          validated={this.getValidation()}
          intl={this.props.intl}
          isLastOnPage={this.props.isLastOnPage}
            questionResponse={questionResponse}
        />;
    }
  }

  render() {
    return this.presentationType()
  }
}

MatrixMulti.propTypes = {
  id: PropTypes.number.isRequired,
  onDetailsUpdated: PropTypes.func.isRequired,
  details: PropTypes.arrayOf(PropTypes.shape({
    row: PropTypes.number.isRequired,
    column: PropTypes.number.isRequired,
    contentRow: PropTypes.string,
    contentColumn: PropTypes.string,
    microTime: PropTypes.number,
  }).isRequired),
  question: PropTypes.shape({
    id: PropTypes.number.isRequired,
    rows: PropTypes.arrayOf(PropTypes.shape({
      id: PropTypes.number.isRequired,
      content: PropTypes.string.isRequired,
      isOpen: PropTypes.bool.isRequired,
    }).isRequired,).isRequired,
    columns: PropTypes.arrayOf(PropTypes.shape({
      id: PropTypes.number.isRequired,
      content: PropTypes.string.isRequired,
      isOpen: PropTypes.bool.isRequired,
    }).isRequired,).isRequired,
    requiredRows: PropTypes.bool.isRequired,
    requiredColumns: PropTypes.bool.isRequired,
    presentationType: PropTypes.oneOf(['table', 'carousel']).isRequired,
  }).isRequired,
  validationTexts: PropTypes.shape({
    requiredRows: PropTypes.string.isRequired,
    requiredColumns: PropTypes.string.isRequired,
    columnsMax: PropTypes.string.isRequired,
    columnsMin: PropTypes.string.isRequired,
    rowsMax: PropTypes.string.isRequired,
    rowsMin: PropTypes.string.isRequired,
  }).isRequired,
  changePage: PropTypes.func.isRequired,
  intl: PropTypes.object.isRequired,
};

export default connect((state) => {
  return {
    startTime: state.timeMeasuring.startTime,
    surveyNav: state.surveyNav,
  }
}, null, null, {withRef: true, forwardRef: true})(MatrixMulti);